import { createContext, useState, useEffect, useCallback, useMemo } from "react";

type Theme = "light" | "dark";

interface IThemeContext {
    theme: Theme;
    toggleTheme: () => void;
}

const defaultThemeContext: IThemeContext = {
    theme: "light",
    toggleTheme: () => {},
};

export const ThemeContext = createContext<IThemeContext>(defaultThemeContext);

export default function ThemeContextProvider({ children }: { children: React.ReactNode }) {
    const [theme, setTheme] = useState<Theme>(() => {
        const stored = localStorage.getItem("theme");
        if (stored === "light" || stored === "dark") {
            return stored;
        }
        return "light";
    });

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        document.documentElement.setAttribute("data-bs-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);

    const toggleTheme = useCallback(() => {
        setTheme((prev) => (prev === "light" ? "dark" : "light"));
    }, []);

    const value = useMemo(() => ({ theme, toggleTheme }), [theme, toggleTheme]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
}
